export default __webpack_public_path__ + "static/media/Disclaimer.194c8f30.svg";